import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoute2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M15 6.75v5.625a3.375 3.375 0 1 1-6.75 0v-6.75a1.875 1.875 0 0 0-3.75 0v5.625H3V5.625a3.375 3.375 0 0 1 6.75 0v6.75a1.875 1.875 0 0 0 3.75 0V6.75z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeWidth: 2,
			d: "M3.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M14.25 5.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
			clipRule: "evenodd"
		})
	]
});
export default SvgRoute2;
